import { render } from "./generic.vue?vue&type=template&id=185b648c&lang=pug"
import script from "./generic.vue?vue&type=script&setup=true&lang=js"
export * from "./generic.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__